import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ButtonContainer from '@components/Common/ButtonContainer';
import { Form, useForm } from '@components/FormElement/Form';

const CreateCompanyForm = ({ isUpdating = false, onSubmit = () => {} }) => {
  const { t } = useTranslation();
  const methods = useForm();

  return (
    <Form methods={methods} onSubmit={onSubmit} isUpdating={isUpdating}>
      <Form.Label title={t('Name')} name="name">
        <Form.Input name="name" required />
      </Form.Label>
      <Form.UploadInput title={t('Logo')} name="logo" filenamesMode="HIDDEN" validTypes={['IMAGE']} required />
      <ButtonContainer position="CENTER">
        <Form.SubmitButton isUpdating={isUpdating} />
      </ButtonContainer>
    </Form>
  );
};

export default CreateCompanyForm;

CreateCompanyForm.propTypes = {
  company: PropTypes.shape({
    name: PropTypes.string,
    logo: PropTypes.string,
  }),
  isUpdating: PropTypes.bool,
  onSubmit: PropTypes.func,
};
